import React from "react";
import { paymentMethods } from "../data/landing";
export function PaymentMethods() {
  return <section className="card" style={{
    padding: 16
  }} data-id="element-122" data-mp="3lq17em0mffzk">
      <div className="pay" style={{
      marginTop: 0
    }} data-id="element-123" data-mp="3logef0tyg53t">
        <h3 className="payt" data-id="element-124" data-mp="3gqexalg3afuz">Formas de pagamento</h3>
        <div className="payl" data-id="element-125" data-mp="3gtax6fbhzem2">
          {paymentMethods.map(m => <img key={m.alt} src={m.src} alt={m.alt} width={80} height={32} loading="lazy" data-id="element-126" data-mp="3brvcwph59c4q" />)}
        </div>
        <div className="pays" data-id="element-127" data-mp="36vemtpqdwnp0">
          <i data-id="element-128" data-mp="3221ylgpmaiws">🔒</i>
          <span data-id="element-129" data-mp="321iryw5f3gy2">Pagamento 100% seguro com criptografia SSL</span>
        </div>
      </div>
    </section>;
}